import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

const proficiencyColors = {
  READING_PROFICIENCY: 'warning',
  SPEAKING_PROFICIENCY: 'info',
  WRITING_PROFICIENCY: 'danger',
  FULL_PROFICIENCY: 'success',
};

const ProficiencyProgressBar = ({ proficiency }) => {
  let value = proficiency === 'FULL_PROFICIENCY' ? 100 : proficiency === 'WRITING_PROFICIENCY' ? 75 : proficiency === 'SPEAKING_PROFICIENCY' ? 50 : 25;
  let color = proficiencyColors[proficiency];

  return (
    <div style={{ width: '100%' }}>
      <ProgressBar now={value} label={`${value}%`} variant={color} />
    </div>
  );
};

export default ProficiencyProgressBar;
